// Module
var code = "<template> <require from=\"app/core/components/member/member-providers\"></require> <member-providers member-id.bind=\"memberId\"></member-providers> </template> ";
// Exports
module.exports = code;